(() => {
  const initialiseModel = (item) => {
    const model = item?.querySelector('model-viewer');
    if (!model) return;

    model.setAttribute('camera-controls', '');
    model.setAttribute('interaction-prompt', 'auto');
    model.setAttribute('reveal', 'auto');
    model.setAttribute('touch-action', 'pan-y');

    const attachUi = () => {
      if (model.dataset.cd13ModelReady === 'true') return;
      if (!window.Shopify?.ModelViewerUI) return;
      try {
        model.cd13ModelUi = new Shopify.ModelViewerUI(model, { focusOnPlay: true });
        model.dataset.cd13ModelReady = 'true';
      } catch (error) {
        console.warn('CD13 model viewer init failed', error);
      }
    };

    attachUi();
    window.setTimeout(attachUi, 150);
    window.setTimeout(attachUi, 600);

    requestAnimationFrame(() => {
      model.updateFraming?.();
      window.dispatchEvent(new Event('resize'));
    });
  };

  const initGallery = (root) => {
    if (!root || root.dataset.mediaReady === 'true') return;
    root.dataset.mediaReady = 'true';

    const items = [...root.querySelectorAll('[data-product-media]')];
    const thumbs = [...root.querySelectorAll('[data-product-media-thumb]')];
    const previousButton = root.querySelector('[data-product-media-prev]');
    const nextButton = root.querySelector('[data-product-media-next]');
    const currentLabel = root.querySelector('[data-product-media-current]');
    const stage = root.querySelector('[data-product-media-stage]');
    let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let pointerStartX = null;

    const comesFromInteractiveMedia = (event) => event.composedPath().some((node) =>
      node instanceof Element && node.matches('model-viewer, video, iframe, .shopify-model-viewer-ui')
    );

    const updateArrows = () => {
      const hasMultipleItems = items.length > 1;
      if (previousButton) previousButton.hidden = !hasMultipleItems || activeIndex === 0;
      if (nextButton) nextButton.hidden = !hasMultipleItems || activeIndex === items.length - 1;
    };

    const activateIndex = (index, options = {}) => {
      if (!items.length) return;
      activeIndex = Math.min(items.length - 1, Math.max(0, index));
      const activeItem = items[activeIndex];
      const activeId = activeItem.dataset.mediaId;

      items.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.hidden = false;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) initialiseModel(item);
        if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
      });

      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaId === activeId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });

      if (currentLabel) currentLabel.textContent = String(activeIndex + 1);
      updateArrows();

      if (options.announce !== false && activeId) {
        root.dispatchEvent(new CustomEvent('cd13:media-change', {
          bubbles: true,
          detail: {
            mediaId: String(activeId),
            mediaIndex: activeIndex,
            source: options.source || 'gallery',
          },
        }));
      }
    };

    root.cd13ActivateMedia = (mediaId, options = {}) => {
      const targetId = String(mediaId);
      const mediaIndex = items.findIndex((item) => item.dataset.mediaId === targetId);
      if (mediaIndex < 0) return false;
      activateIndex(mediaIndex, {
        announce: options.announce !== false,
        source: options.source || 'api',
      });
      return true;
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      activateIndex(Number(thumb.dataset.mediaIndex || 0), { source: 'thumbnail' });
    }));
    previousButton?.addEventListener('click', () => {
      activateIndex(activeIndex - 1, { source: 'previous' });
    });
    nextButton?.addEventListener('click', () => {
      activateIndex(activeIndex + 1, { source: 'next' });
    });

    stage?.addEventListener('pointerdown', (event) => {
      if (comesFromInteractiveMedia(event)) return;
      pointerStartX = event.clientX;
    });

    stage?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || comesFromInteractiveMedia(event)) {
        pointerStartX = null;
        return;
      }
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 45) return;
      if (delta < 0 && activeIndex < items.length - 1) {
        activateIndex(activeIndex + 1, { source: 'swipe' });
      }
      if (delta > 0 && activeIndex > 0) {
        activateIndex(activeIndex - 1, { source: 'swipe' });
      }
    });

    activateIndex(activeIndex, { announce: false, source: 'initial' });
  };

  const init = (scope = document) => {
    const galleries = scope.matches?.('[data-product-media-gallery]')
      ? [scope]
      : scope.querySelectorAll('[data-product-media-gallery]');
    galleries.forEach(initGallery);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  window.addEventListener('load', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
